const aboutUs = {
  title: "About Us",
  text: "We are professional sound engineers and session musicians, delivering the best music possible."
};

const history = {
  title: "History",
  text: "We graduated in Conservatoire. And Berklee. And Liszt Ferenc Unversity. Cool places."
};


export { aboutUs, history }